import React from "react";
import Image from "next/image";
import { SingleProductDescriptionFocusedPrice } from "./SingleProductDescriptionFocusedPrice";
import { giftCardItem } from "@/utils/giftCardUtils";
import { SingleProductDescriptionFocusedDuration } from "./singleProductionDescriptionFocusedDuration";

export interface SingleProductProps {
  product: any;
  isRetailMerchant?: boolean;
  merchantName: string;
}

export const SingleProductDescriptionFocused = ({
  product,
  isRetailMerchant,
  merchantName,
}: SingleProductProps) => {
  const isGiftCardProduct = product.id === giftCardItem.id;
  const productImage =
    product.images && product.images.length > 0
      ? product.images.reduce((prev: any, current: any) => {
          if (
            current.name.includes("xxxhdpi") ||
            (current.name.includes("xxhdpi") &&
              !prev.name.includes("xxxhdpi")) ||
            (current.name.includes("xhdpi") &&
              !prev.name.includes("xxhdpi") &&
              !prev.name.includes("xxxhdpi"))
          ) {
            return current;
          }
          return prev;
        }, product.images[0])
      : null;

  const giftCardDescription = `Can be used for any purchase at ${merchantName}. A great gift idea.\nNo tax will be applied at purchase`;
  return (
    <div
      key={product.id}
      data-testid="single-product"
      className="flex relative h-[120px] shadow-md rounded-b-md cursor-pointer bg-white"
    >
      <div className="w-full flex flex-col justify-between px-3 pt-4 pb-3">
        <div className="flex justify-between">
          <div className="flex flex-col sm:flex-row">
            <span className="line-clamp-1 text-lg font-medium">
              {product.name}
            </span>
            {product.serviceItem && !isGiftCardProduct && (
              <SingleProductDescriptionFocusedDuration
                duration={product?.serviceItem?.duration}
              />
            )}
          </div>
          <SingleProductDescriptionFocusedPrice
            product={product}
            isGiftCardProduct={isGiftCardProduct}
            isRetailMerchant={isRetailMerchant}
          />
        </div>
        <span
          data-testid="product-description"
          className="text-wrap line-clamp-2 text-[15px]"
        >
          {!isGiftCardProduct ? product.description : giftCardDescription}
        </span>
      </div>
      {productImage && (
        <div className={"flex flex-shrink-0 w-[120px] h-[120px]"}>
          <Image
            width={120}
            height={120}
            alt={product.imageAlt || "product image"}
            src={productImage.source}
            className="object-cover object-center w-full h-full rounded-r-md"
          />
        </div>
      )}
      {!product.available && (
        <div className="absolute h-full w-full inset-0 bg-white opacity-50 rounded-md"></div>
      )}
    </div>
  );
};
